import React,{useState,useEffect} from 'react';
import {Link,useLocation} from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import Logo from '../common/Logo';
import * as FiIcons from 'react-icons/fi';

const {FiMenu,FiX}=FiIcons;

const Navbar=()=> {
  const [isScrolled,setIsScrolled]=useState(false);
  const [mobileMenuOpen,setMobileMenuOpen]=useState(false);
  const location=useLocation();

  useEffect(()=> {
    const handleScroll=()=> setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll',handleScroll);
    return ()=> window.removeEventListener('scroll',handleScroll);
  },[]);

  useEffect(()=> {
    setMobileMenuOpen(false);
  },[location]);

  const navLinks=[
    {name: 'Features',path: '/features'},
    {name: 'Pricing',path: '/pricing'},
    {name: 'Use Cases',path: '/use-cases/course-creators'},
    {name: 'Blog',path: '/blog'},
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-brand-dark/95 backdrop-blur-2xl border-b-2 border-brand-electric/30 shadow-[0_0_30px_rgba(0,229,255,0.2)]'
          : 'bg-brand-dark/80 backdrop-blur-xl'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/">
            <Logo size="default" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link)=> (
              <Link
                key={link.name}
                to={link.path}
                className="text-base font-semibold text-white/90 hover:text-brand-electric transition-all duration-300 relative group"
              >
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-brand-neon to-brand-electric group-hover:w-full transition-all duration-300 shadow-[0_0_10px_rgba(0,229,255,0.5)]"></span>
              </Link>
            ))}
          </nav>

          {/* CTA */}
          <div className="hidden md:flex items-center gap-4">
            <Link
              to="#"
              className="text-base font-semibold text-white hover:text-brand-electric transition-colors"
            >
              Log In
            </Link>
            <button className="btn-cta py-3 px-6 text-sm text-brand-neon">
              Start Free
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-brand-electric p-2 hover:bg-brand-electric/10 rounded-lg transition-colors border border-brand-electric/30"
            onClick={()=> setMobileMenuOpen(!mobileMenuOpen)}
          >
            <SafeIcon icon={mobileMenuOpen ? FiX : FiMenu} className="text-2xl text-brand-electric" />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-brand-card/98 backdrop-blur-2xl mx-4 mt-2 mb-4 rounded-2xl border-2 border-brand-electric/30 shadow-[0_0_30px_rgba(0,229,255,0.2)]">
          <div className="p-4 flex flex-col gap-2">
            {navLinks.map((link)=> (
              <Link
                key={link.name}
                to={link.path}
                className="text-white font-semibold p-3 hover:bg-brand-electric/10 rounded-lg transition-all hover:text-brand-electric border border-transparent hover:border-brand-electric/30"
              >
                {link.name}
              </Link>
            ))}
            <div className="h-px bg-brand-electric/20 my-2"></div>
            <Link
              to="#"
              className="text-white font-semibold p-3 hover:bg-brand-electric/10 rounded-lg transition-colors"
            >
              Log In
            </Link>
            <button className="btn-cta w-full mt-2 text-brand-neon">
              Start Free
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;